import { render, staticRenderFns } from "./dormDistributionQuery.vue?vue&type=template&id=6af667dd&scoped=true"
import script from "./dormDistributionQuery.vue?vue&type=script&lang=js"
export * from "./dormDistributionQuery.vue?vue&type=script&lang=js"
import style0 from "./dormDistributionQuery.vue?vue&type=style&index=0&id=6af667dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af667dd",
  null
  
)

export default component.exports